import * as dayjs from 'dayjs'

export const normalizeToTableСampaign = (serverCampaign) => {
  return {
    ...serverCampaign,
    date: `${dayjs(serverCampaign.effective_date).format('DD.MM.YYYY')} -
      ${dayjs(serverCampaign.expiration_date).format('DD.MM.YYYY')}`,
  }
}
